export default __webpack_public_path__ + "static/b1-d7b0e7475bedd8b9030bc31a18fc0cf5.png";